import { gql } from 'graphql-request'

export const CREATE_BAN_IMAGE_LOG = gql`
  mutation CreateBanImageLog(
    $createBanImageLogInput: CreateBanImageLogsInput!
  ) {
    createBanImageLog(createBanImageLogInput: $createBanImageLogInput)
  }
`
